import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  PROFILE_SELF_CONCEPTS,
} from '../../../constants';


class ProfilesTriplePersonality extends Component {
  render() {
    return (
      this.props.personality !== undefined && (
        <div className="row fullwidth" id="profileTriplePersonalityPdf">
          {/* <div className="row demographic-detail-columns fullwidth">
                    <p className="profile-triple-attitude-statement"
                    title={this.props.personality.personality.label}>
                    {this.props.personality.personality.label}</p>
            </div> */}
          <div className="row demographic-detail-columns fullwidth">
            <div
              className="profile-triple-attitude-statement"
              title={this.props.personality[0][1].label}
            >
              <p className="profile-triple-persona-header-block">
                {this.props.personality[0][1].label}
              </p>
            </div>
          </div>
          <div className="div-overflow">
            <div
              className="attitude-triple-comparision-metrics profile-triple-personality-statement-matrix"
              id="profile-triple-index-pdf"
            >
              INDEX:&nbsp;&nbsp;{this.props.personality[0][1].value.index}{' '}
              | REACH:&nbsp;&nbsp;{this.props.personality[0][1].value.pct}{' '}
            </div>
          </div>
          <div className="row demographic-detail-columns fullwidth">
          {this.props.personality[1][0] === PROFILE_SELF_CONCEPTS &&
            <div
              className="profile-triple-self-concepts"
              title={this.props.personality[1][1].label}
            >
              <p className="triple-person-profile-self-concepts">
                ({this.props.personality[1][1].label})
              </p>
            </div>
          }
          </div>
        </div>
      )
    );
  }
}

ProfilesTriplePersonality.propTypes = {
  personality: PropTypes.shape({}),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(ProfilesTriplePersonality);
